import { Button, Modal, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import classes from '../../app.module.css';
import { useDisclosure } from '@mantine/hooks';
import { useKeycloakStore, useUserDataStore } from '../../shared_stores';
import { useReportsStore } from '../../modules/reports/stores';
import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { DateTime } from 'luxon';

export const FormulaUpdateModal = observer(() => {
  const { t } = useTranslation(['reports']);
  const [opened, { open, close }] = useDisclosure(false);
  const kcStore = useKeycloakStore();
  const reportsStore = useReportsStore();
  const userDataStore = useUserDataStore();

  useEffect(() => {
    if (!reportsStore.loadedMeasurementList) {
      void reportsStore.loadAllMeasurements(kcStore.token);
    }
  }, [reportsStore, kcStore.token]);

  useEffect(() => {
    if (reportsStore.formulaUpdateNeeded) {
      if (
        reportsStore.latestFormulaCreatedAt &&
        userDataStore.userInfo?.fsUpdateDismissedAt
      ) {
        const dismissedAt = DateTime.fromJSDate(
          userDataStore.userInfo?.fsUpdateDismissedAt,
        );
        const latestFormulaDate = DateTime.fromJSDate(
          reportsStore.latestFormulaCreatedAt,
        );
        const showModal = latestFormulaDate > dismissedAt;
        if (showModal) {
          open();
        }
      }
    }
  }, [open, reportsStore, userDataStore]);

  const handleUpdate = () => {
    void reportsStore.updateFormulas(kcStore.token);
    close();
  };

  const handleDismiss = () => {
    if (userDataStore.userInfo) {
      void userDataStore.updateUserInfo(kcStore.token, {
        ...userDataStore.userInfo,
        fsUpdateDismissedAt: new Date(),
      });
    }
    close();
  };

  return (
    <Modal
      classNames={{ content: classes.modalContentWhite }}
      opened={opened}
      withCloseButton={false}
      onClose={handleDismiss}
      title={t('reports:formula_update_title')}
    >
      <Stack>
        <Text>{t('reports:formula_update_paragraph_1')}</Text>
        <Text>{t('reports:formula_update_paragraph_2')}</Text>
        <Button onClick={handleUpdate}>{t('update_now')}</Button>
        <Button variant="outline" onClick={handleDismiss}>
          {t('update_later')}
        </Button>
      </Stack>
    </Modal>
  );
});
